/**
 * Stim shot. Heals more than a bandage and faster, stops no bleeding, and weighs almost nothing,
 * which is what makes the two consumables a choice rather than a ranking.
 */

import type { ConsumableItem } from '@/sim/items/itemContract';

export const STIM_SHOT = {
  id: 'stimShot',
  kind: 'consumable',
  label: 'Stim shot',
  description: 'Auto-injector. Halcyon considered the side effects acceptable.',
  rarity: 'uncommon',
  weightKg: 0.08,
  stackLimit: 6,
  equip: null,
  healAmount: 45,
  clears: [],
  useTicks: 90,
} as const satisfies ConsumableItem;
